import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateTeachingStaffRoleDto {
  @ApiProperty({
    type: 'string',
    description: 'Code du rôle du personnel enseignant',
    example: 'TEACHER',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    type: 'string',
    description: 'Nom du rôle du personnel enseignant',
    example: 'Enseignant',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
